module.exports = __webpack_public_path__ + "static/media/Flik1.459001d4.pdf";